export default "__VITE_ASSET__DCkKUYJl__"